<div fxLayout>
  <main fxFlex style="padding: 0px; margin-bottom: 0">
    <picture>
      <source srcset="assets/images/demo/gx/gx.webp" type="image/webp" />
      <img src="assets/images/demo/gx/gx.svg" class="demo-ux-image" (load)="isImageLoaded = true" />
    </picture>

    <div class="demo-callout rules__intro-text" *ngIf="isImageLoaded">
      <ng-container *ngIf="userTrialConnectAccountCta$ | async as userTrialConnectAccountCta">
        <h2>Automate communication like never before!</h2>
        <p class="notification__description">
          Send super-friendly guest messages, and answer all their questions while you sleep. Guest Experience provides
          the most robust messaging tool in the industry and allows you to automate responses to your guests’ questions.
          You can even automate the review process and schedule reminders, such as taking the trash out on certain days
          of the week.
        </p>
        <p class="notification__description">
          Connect your {{ userTrialConnectAccountCta?.platformUi | titlecase }} account to import your listings into
          your Hospitable.com account and automate your guest communication today!
        </p>

        <div class="rules__intro-buttons" fxLayout fxLayout.lt-md="column" fxLayoutGap="16px">
          <button mat-flat-button (click)="clickedPrimaryCta(userTrialConnectAccountCta.connectAccountUrl)">
            Connect with {{ userTrialConnectAccountCta?.platformUi | titlecase }}
          </button>

          <a
            mat-flat-button
            class="button__secondary"
            (click)="
              clickedSecondaryCta(
                'https://my.hospitable.com/support-documentation/article/720073-getting-started-with-guest-experience'
              )
            ">
            Learn more
          </a>
        </div>
      </ng-container>
    </div>
  </main>
</div>
